<template>
  <div>
    <div class="text-xs-right">
      <v-btn @click="$emit('close')" icon> <v-icon>close</v-icon></v-btn>
    </div>
    <div class="px-4 pb-4">
      <div>ชื่อกลุ่ม</div>
      <div class="form-control" :class="{ 'has-error': errors.has('ชื่อกลุ่ม') }">
        <input
          placeholder="กรอกชื่อกลุ่ม"
          v-model="input.name"
          type="text"
          name="ชื่อกลุ่ม"
          v-validate="'required'"
        />
        <p class="text-error" v-if="errors.has('ชื่อกลุ่ม')">
          {{ errors.first('ชื่อกลุ่ม') }}
        </p>
      </div>
      <div class="text-xs-center">
        <v-btn @click="$emit('close')" outline color="grey">cancel</v-btn>
        <v-btn :loading="saveloading" @click="onSave" depressed color="primary">
          {{ edittype == 'edit' ? 'Save' : 'Create' }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: ['edittype', 'editdata'],
  computed: {
    ...mapGetters(['selectedBot'])
  },
  data() {
    return {
      saveloading: false,
      input: {
        name: ''
      }
    }
  },
  mounted() {
    if (this.edittype == 'edit') {
      console.log(this.editdata)
      this.input = this.editdata
    }
  },
  methods: {
    async onSave() {
      if (await this.$validator.validate()) {
        if (this.edittype == 'create') {
          this.createData()
        } else {
          this.editData()
        }
      }
    },
    createData() {
      this.saveloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        name: this.input.name
      }
      api.createPowerbuyGroup(data, (err, response) => {
        this.saveloading = false
        this.$emit('onSave')
      })
    },
    editData() {
      this.saveloading = true
      var data = {
        id: this.input.id,
        pageid: this.selectedBot.pageid,
        name: this.input.name
      }
      api.editPowerbuyGroup(data, (err, response) => {
        this.saveloading = false
        this.$emit('onSave')
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/Management/PageGroupEdit.vue